import React from 'react'
import styles from './NewDealProductItem.module.scss'
import { NewDealBackground} from '../../../../assets/icons'
import { NewDealSolarProduct } from '../../../../model/solar-product/new-deal-solar-product'
import { useNavigate } from 'react-router-dom'
import { ApplicationRoutes } from '../../../../routes'

type Props = {
    product: NewDealSolarProduct
}

const NewDealProductItem: React.FC<Props> = (props: Props) => {
    const { product } = props

    const navigate = useNavigate();

    const generateMonthlyRepaymentDurationPlan = (product: NewDealSolarProduct): string => {
        return `${product.minimumNumberOfRepaymentMonths} — ${product.maximumNumberOfRepaymentMonths} Months Plan`
    }

    const navigateToProductDetails = () => {
        navigate(`/${ApplicationRoutes.STORE_FRONT_ITEM}/${product.id}`)
    }

    return (
        <button className={styles.container} onClick={navigateToProductDetails}>
            <div className={styles.imageContainer}>
                <img src={product.images[0].imageUrl} alt="Product" /> 
                <div className={styles.imageContainerBackground}>
                    <NewDealBackground className={styles.sun} />
                </div>
                <div className={styles.priceInfoContainer}>
                    <h3 className={styles.price}>{product.price.toLocaleString()}</h3>
                    <h5 className={styles.deposit}>30% Initial deposit</h5>
                </div>
            </div>
            <h3 className={styles.name}>{product.name}</h3>
            <p className={styles.description}>Up to {product.activeDuration} Hours</p>
            <p className={styles.description}>{product.productCapacity} KVA</p>
            <p className={styles.description}>{generateMonthlyRepaymentDurationPlan(product)}</p>
        </button>
    )
}

export default NewDealProductItem